/**
 * User roles with IDs as defined in the DB.
 *
 * Never change or reuse an ID!
 * Consider this object immutable - never modify it at runtime!
 */
const UserRoles = {

    // Define role id's as 1, 2, 4, 8, 16.... allowing users to have multiple roles using a single database field
    USER: {id: 1},
    CLUB_ADMIN: {id: 2},
    SECTION_ADMIN: {id: 4},
    MAIN_ADMIN: {id: 8},
    ALLOW_ANONYMOUS: null, // <- a special entry which is not a real role, but rather a lack of role. Used in controllers to signal anonymous access is allowed. (Perhaps remove it from here?)


    /** Get list of all user roles (not including ALLOW_ANONYMOUS)*/
    values: () => {
        const values = [];
        for (const userRoleName in UserRoles) {
            if (UserRoles.hasOwnProperty(userRoleName)) {
                const userRole = UserRoles[userRoleName];
                if (typeof(userRole) !== "function" && userRole !== UserRoles.ALLOW_ANONYMOUS)
                    values.push(userRole);
            }
        }
        return Immutable.List(values);
    },

    /** Get user role by id */
    getById: (id) => {
        if (typeof(id) === "string") id = parseInt(id);

        for (const userRole of UserRoles.values())
            if (userRole.id === id)
                return userRole;

        throw new Error("The User Role id " + id + " does not correspond to an existing User Role.");
    }
};

export default UserRoles;



// WEBPACK FOOTER //
// ./src/common/src/enums/UserRoles.js